function okazoTabIndex(event, tabs) {
  if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) return null;
  event.preventDefault();
  const current = tabs.indexOf(event.currentTarget);
  if (event.key === "Home") return 0;
  if (event.key === "End") return tabs.length - 1;
  const direction = ["ArrowLeft", "ArrowUp"].includes(event.key) ? -1 : 1;
  return (current + direction + tabs.length) % tabs.length;
}

function initOkazoImageFallbacks() {
  document.addEventListener(
    "error",
    (event) => {
      const image = event.target;
      if (!(image instanceof HTMLImageElement)) return;

      const host = image.closest("[data-okz-image-fallback]");
      if (!host) return;

      host.classList.add("is-image-broken");
    },
    true,
  );
}

initOkazoImageFallbacks();
